console.log('js/topic-hero.js -> v0.1.0');

$(function() {

	if( typeof(tpHeroVideo) != 'undefined' ){

		if ( $(window).width() > 1440 ) {
			tpHeroVideoName = tpHeroVideoName_fullhd;
			tpHeroVideoThumb = tpHeroVideoThumb_fullhd;
		} else if ( $(window).width() > 1025 ) {
			tpHeroVideoName = tpHeroVideoName_hd;
			tpHeroVideoThumb = tpHeroVideoThumb_hd;
		} else {
			tpHeroVideoName = tpHeroVideoName_mobile;
			tpHeroVideoThumb = tpHeroVideoThumb_mobile;
		}

		if ( $(window).width() > 1025) {
			$('.tp_video_hero .hero-background-container').append(`
				<div class="video_hero" style="display:none;">
					<video autoplay loop defaultMuted muted width='100%' height='100%' poster="`+ tpHeroVideoThumb + `" src="` + tpHeroVideoName+`" preload="auto" type='video/mp4'></video>
				</div>
			`);

			$('.video_hero video').each(function(){
				gae('topicPage','videoHero__init');
				$(this).on('play',function(){
					gae('topicPage','videoHero__play');
				});
			});
			$("body").data("showModalWhenLeavingWindow", 0);
			$('.hero-background').removeClass('zoom-in');
			$('.video_hero').delay(3).fadeIn(500);

			if ( $(window).width() < 1025 )
				$('.search__hero .box-container').addClass('box-container--expanded');
		}
	}


	// tp_video_hero START

	if($(window).width() > 1024 && $('.tp_video_hero').length && typeof(tpHeroVideo) == 'undefined' ){
		var prefix = $('[data-video-prefix]').attr('data-video-prefix');
		if(typeof(prefix) != 'undefined'){
			var file = prefix+'_1440.mp4';

			if($(window).width() > 1440){
				var file = prefix+'_1920.mp4';
			};
			gae('ufl','index__init--'+file);

			$('.tp_video_hero .hero-background-container').append(`
				<div class="video_hero" style="display:none;">
					<video autoplay loop defaultMuted muted width='100%' height='100%' poster="`+ prefix + `_still.jpg" src="` + file+`" preload="auto" type='video/mp4'></video>
				</div>
			`);

			$('.video_hero video').each(function(){
				gae('topicPage','videoHero__init');
				$(this).on('play',function(){
					gae('topicPage','videoHero__play');
				});
			});
			$("body").data("showModalWhenLeavingWindow", 0);
			$('.video_hero').delay(3).fadeIn(500);
		};
	}

});
